import Marionette from 'backbone.marionette';
import { ActivateGameView } from '../../views';

import UserModel from '../../../../core/models/User';
import { redirectTo } from '../../../../core/utils';

export default class ActivateGameController extends Marionette.Object {
	activateGame() {
		if (UserModel.isGameRecovered()) {
			return redirectTo();
		}

		const rootView = this.getOption( 'rootView' );
		rootView.getRegion( 'main' ).show(new ActivateGameView());
	}
}